<template>
  <router-view/>
</template>
<script>
  export default {
    name: 'RealMockExam'
  }
</script>
<style lang="scss">
.stepContainer{
  width:100%;
  min-height:100%;
}
</style>